<template>
  <div>
    <header-sales></header-sales>

    <div id= "subheader"> </div>

    <div id= "main-container">
      <div id= "label-container">
        <span id="label">Carrito de Compras</span>
      </div>
      <div id= "container">
        <div id= "header-pedido">
            <div class="fh rc" style="width: 100%; height: 100%"> 
                <div class="fh cb" style="font-size: 13px; color:#5D6770; margin-right: 30px">Subtotal: {{moneyLabel}} {{subtotal | formatMoney}} </div>
                <div class="fh cb" style="font-size: 16px; color:#5D6770; margin-right: 36px; font-weight: 500">Total: {{moneyLabel}} {{total | formatMoney}} </div>
            </div>
        </div>
        <div id="list-container">
          <item-pedido id="list-prod" v-for="item in items" :item='item' @eliminarItem="btnEliminarItem"  ></item-pedido>
        </div>
        <div id="btnContainer">
          <input id="btnEliminar" @click="btnEliminar" type="submit" value="ELIMINAR">
          <input id="btnGuardar" @click="btnGuardar" type="submit" value="GUARDAR">
          <input id="btnAgregar" @click="btnAgregar" type="submit" value="AGREGAR ITEM">
          <input id="btnAgregar" @click="btnAgregarPromo" type="submit" value="AGREGAR PROMO">
          <input id="btnEnviar" @click="btnEnviar" type="submit" value="ENVIAR">
        </div>
      </div>
    </div>


   <!--popup up-->
   <transition name="fadePro">
   <div v-show='showPopup' :showPopup='showPopup'>

     <div id='back-popup'>
     </div>


     <div id='popup-envio-pedido'>

       <div id='popup-btnClose-container'>
        <img id='btnClose' @click="btnCerrarPopup" src="/dist/btnClose.png" style="width: 20px;height: 20px">
       </div>

       <p id='popup-titulo' style="margin-bottom: 20px">Enviar Pedido</p>
          
       <div class="labelsForms">Condición de venta</div>
       <select class="wc" v-model="condicionVenta">
         <option v-for="option in condicionesVenta" v-bind:value="option">{{ option.Nombre }}</option>
       </select>
       
       <div class="labelsForms">Fecha de despacho</div>
       <datepicker wrapper-class="wc" input-class="datepicker-ic" :disabledDates="disabledDates" v-model="calendario" :language="es"> </datepicker>

       <div class="labelsForms">Sucursal de entrega</div>
       <select class="wc" v-model="sucursal">
         <option v-for="option in sucursales" v-bind:value="option">{{ option.Nombre }}</option>
       </select>

       <div class="labelsForms" v-show="showEnviaCopiaPedido">Enviar copia del pedido</div>
       <select class="wc" v-model="contacto" v-show="showEnviaCopiaPedido">
         <option v-for="option in contactos" v-bind:value="option">{{ option.Contacto }}</option>
       </select>

       <div class="labelsForms">Orden de compra</div>
       <input class="wc" style="margin-left: 30px" v-model="ordenCompra">

       <div :class='{labelsForms:lengthObsFact,labelsFormsInv:!lengthObsFact}'>Observaciones Facturación {{observacionesFacturacionCount}}</div>
       <textarea id='obs' v-model="observacionesFacturacion" v-on:keyup="onKeyDownHandler" style="height: 20px"> </textarea>

       <div :class='{labelsForms:lengthObsPlanta,labelsFormsInv:!lengthObsPlanta}'>Observaciones Planta {{observacionesPlantaCount}}</div>
       <textarea id='obs' v-model="observacionesPlanta" v-on:keyup="onKeyDownHandler" style="height: 20px"> </textarea>

       <div id="btnContainerPopup">
         <button  @click="btnCerrarPopup" id="btnclose">CANCELAR</button>
         <button  @click="btnEnviarPopup" id="btnsend">ENVIAR</button>
       </div>

     </div>

   </div>
  </transition>


  </div>
</template>


<script>
  import axios from 'axios'
  import HeaderSales from '@components/views/header.vue';
  import ItemPedido from '@components/views/pedido/ItemPedido.vue';
  import Vue from 'vue'
  import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
  //import * as lang from "vuejs-datepicker/src/locale";
  import { es } from 'vuejs-datepicker/dist/locale';
  import moment from 'moment'

  export default {
    name: 'Pedido',
    components:{
     'header-sales': HeaderSales,
     'item-pedido': ItemPedido,
     Datepicker
    },


    data() {
       return {
         showPopup:false,
         es,
         productos:[],
         pedido:null,
         observacionesFacturacion:'',
         observacionesPlanta:'',
         observacionesFacturacionCount:'(0/60)',
         observacionesPlantaCount:'(0/60)',
         grupoProductos:  [],
         descuentosAplicados: [],
         descuentosPedido: [],          
         descuentosSend: [],
         sucursal: "",
         condicionVenta:"",  
         contacto:"",
         numPedidoEdit:false,
         idItemEliminar:-1,
         fechaDespacho:'',
         bonificacion:0,
         ordenCompra:"",
         calendario:"",
         aplicaRecargoPedidoMinimo:false,
         errorMsg: "",
         disabledDates: 
         {
           to: null,
           days: [],
           dates:[]
         }

       }
    },


    computed: {

      lengthObsFact() 
      {
        if (this.observacionesFacturacion.length < 61)
        {
           return true
        } 
        else
        {
           return false
        }  
      },

      lengthObsPlanta() 
      {
        if (this.observacionesPlanta.length < 61)
        {
           return true
        } 
        else
        {
           return false
        }  
      },

      moneyLabel() 
      {
        if (this.$store.state.pedido.idMoneda == 2)
        {
          return 'U$S' 
        }
        else
        {
          return '$' 
        }
      },

      numPedido(){
        if ((this.$store.state.pedido.pedidosHome != null) && (this.$store.state.pedido.pedidosHome.length > 0))
        {
          return this.$store.state.pedido.pedidosHome[0].Id
        }
        else
        {
          return 0
        }
      },

      showEnviaCopiaPedido(){
        return this.$store.state.user.cliente.EnviaPedido
      },


      items () 
      {
        var des          = [];
        var pedidoMinimo = 0 
        var currentDate  = new Date() 

        var car = this.$store.state.pedido.carrito;
       
        if (car.length > 0)
        {
          if ((this.$store.state.user.cliente.ValidaMontoMinimoPedido) && (this.conversionMoneda(this.calcularSubtotal(),'producto') < this.conversionMoneda(this.$store.state.pedido.deposito.PedidoMinimo,'deposito')))
          {
              this.aplicaRecargoPedidoMinimo = true  
              var cargoPedido = { archivoId:0,
                            cantidad:1,
                            descripcion:'',
                            id:0,
                            idCategoria:0,
                            idSubcategoria:0,
                            peso:0,
                            precioIngresado: this.conversionMoneda(this.$store.state.pedido.deposito.CargoPedidoMinimo,'deposito'),
                            producto:'Cargo por pedido mínimo',
                            tipoOblea:2
                          }
                des.push(cargoPedido);
          }
          else
          {
            this.aplicaRecargoPedidoMinimo = false  
          }

          var vigenciaMillis = 0
          var actualMillis   = 0 

          if (this.$store.state.user.cliente.BonificacionVigencia) {
              vigenciaMillis = moment(this.$store.state.user.cliente.BonificacionVigencia, "DD/MM/YYYY").toDate().getTime()
              actualMillis   = Date.now()
          }


          if ((this.$store.state.user.cliente.BonificacionValor > 0)
               && (vigenciaMillis)&&(vigenciaMillis>0)&&(actualMillis>0)&&(actualMillis<vigenciaMillis)) {
            
              if (this.$store.state.user.cliente.BonificacionEsPorcentaje) {
                  this.bonificacion = (this.$store.state.user.cliente.BonificacionValor/100) *  this.calcularSubtotal()   
              } 
              else {
                  this.bonificacion = this.$store.state.user.cliente.BonificacionValor
              } 
            
              this.bonificacion = this.conversionMoneda(this.bonificacion,'producto')

              var bonif = { archivoId:0,
                            cantidad:1,
                            descripcion:'',
                            id:0,
                            idCategoria:0,
                            idSubcategoria:0,
                            peso:0,
                            precioIngresado: this.bonificacion,
                            producto:'Bonificación del cliente',
                            tipoOblea:2
                           }
              des.push(bonif);
          }

        } 
        return car.concat(des);
      },


      subtotal () {
        return (this.conversionMoneda(this.calcularSubtotal(),'producto')).toFixed(2)
      },


      total () {
        var cargoPedidoMinimo = 0.0
        var validaMinimo = this.$store.state.user.cliente.ValidaMontoMinimoPedido
        var subtotal = this.conversionMoneda(this.calcularSubtotal(),'producto')
        var pedidoMinimo = this.conversionMoneda(this.$store.state.pedido.deposito.PedidoMinimo,'deposito') 
        if (validaMinimo && (subtotal<pedidoMinimo)) {
            cargoPedidoMinimo = this.conversionMoneda(this.$store.state.pedido.deposito.CargoPedidoMinimo,'deposito')
        }
        return  (subtotal + cargoPedidoMinimo - this.bonificacion).toFixed(2) 
      },



      condicionesVenta () {
        return this.$store.state.user.cliente.CondicionesVenta;
      },

      sucursales () {
        return this.$store.state.user.cliente.Sucursales;
      },

      contactos () {
        return this.$store.state.user.cliente.Contactos;
      },

    },


  methods: {

    onKeyDownHandler() {
      this.observacionesFacturacionCount = '('+this.observacionesFacturacion.length+'/60)'   
      this.observacionesPlantaCount = '('+this.observacionesPlanta.length+'/60)'   
    },

    btnCalendario() 
    {

    },

    btnEdit() {
      if (this.numPedidoEdit)
      {
        this.numPedidoEdit = false
      }
      else
      {
        this.numPedidoEdit = true
      }
    },
 
    calcularSubtotal () {
      var st= 0.0;
      this.$store.state.pedido.carrito.forEach(function(element) {
        st = st + (element.precioIngresado * element.cantidad);
      });
      return st;
    },


    validar() {
        var rex = new RegExp(/^\d+$/);
        var ok = true;
        this.$store.state.pedido.carrito.forEach((e)=> {
            //todos  
            if (!rex.test(e.cantidad)) {
            this.errorMsg = 'Todos los campos cantidad deben contener valores numéricos enteros mayores a 0'
            ok = false;
            }
            if (e.cantidad < 1) {
            this.errorMsg = 'Todos los campos cantidad deben contener valores numéricos enteros mayores a 0'
            ok = false;
            }
            
            if (e.esPromo) {
                //promos  
                if ((e.esPromo) && (e.tieneLimiteMaximo) && (e.cantidad > e.limiteMaximo)) {
                    this.errorMsg = 'Uno o mas ítems promoción del pedido ha sobrepasado la cantidad máxima de unidades'
                    ok = false;  
                } 
                if (e.cantidad % e.unidadesPorPedido != 0) {
                    this.errorMsg = 'Uno o mas ítems del pedido no es un múltiplo valido de la unidad de pedido'
                    ok = false;  
                }
                if (e.pesoMinimoPedido > 0) {
                   if ((e.cantidad * e.peso) < e.pesoMinimoPedido) {
                      this.errorMsg = 'El ítem ' + e.producto + ' no alcanza el peso minimo por pedido. (Peso: ' + (e.cantidad * e.peso) + 'Kg) (Peso minimo: ' + e.pesoMinimoPedido +'Kg)'
                      ok = false;  
                   }
                }
            }
            else {
                //productos  
                if (Number(e.cantidad) < Math.ceil(e.pesoMinimoPedido/e.peso)) {
                    this.errorMsg = 'Uno o mas ítems del pedido no alcanza el peso mínimo requerido'
                    ok = false;  
                } 
                if ((e.cantidad % e.unidadesPorPedido) != 0) {
                    this.errorMsg = 'Uno o mas ítems del pedido no es un múltiplo valido de la unidad de pedido'
                    ok = false;  
                } 
            }
        });
      return ok;
    },


    btnEliminarItem(id) 
    {
      this.idItemEliminar = id
      var obj = {
                 txt:'¿Desea eliminar el item del pedido?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarItem
                }
      this.$store.commit('popup/open',obj);
    },


    eliminarItem() 
    {
      this.$store.commit('pedido/eliminarItemPedido',this.idItemEliminar)   
      if (this.$store.state.pedido.carrito.length > 0)
      {
        this.$router.push({ name: 'reload' });
      }
      else
      {
        this.$router.push({ name: 'home' });
      }
    },



    btnEliminar() 
    {
      var obj = {
                 txt:'¿Desea eliminar el pedido?',
                 txtBtnCancel:'Cancelar',
                 txtBtnOk:'Aceptar',
                 fCancel:null,
                 fOk:this.eliminarPedido
                }
      this.$store.commit('popup/open',obj);
    },


    eliminarPedido() 
    {
      this.$store.commit('pedido/eliminarPedido')
      this.$router.push({ name: 'home' });
    },


     btnAgregar() 
     {
       this.$router.push({ name: 'realizarPedidoCat' });
     },

     btnAgregarPromo() 
     {
       this.$router.push({ name: 'promociones' });
     },



     btnCerrarPopup() 
     {
       this.showPopup = false;
     },


     btnEnviar() 
     {
       if (this.validar())
       {
         this.showPopup = true;
       }
       else
       {
         var obj = {
                     txt: this.errorMsg,
                     txtBtnCancel:'',
                     txtBtnOk:'Aceptar',
                     fCancel:null,
                     fOk:null
                   }
         this.$store.commit('popup/open',obj);
       }
     },



//----------------------- ENVIAR PEDIDO --------------------------

     envioValido()
     {
        var valido = true  
        var msg = '' 

        if (this.observacionesFacturacion.length > 60)
        {
          valido = false    
          msg = 'El campo observaciones de facturación no puede contener más de 60 caracteres.'
        } 
        if (this.observacionesPlanta.length > 60)
        {
          valido = false    
          msg = 'El campo observaciones de planta no puede contener más de 60 caracteres.'
        } 
        if ((this.contacto=="")&&(this.$store.state.user.cliente.EnviaPedido))
        {
          valido = false    
          msg = 'Debe ingresar contacto a quien enviar copia de pedido  para poder continuar.' 
        }
        if (this.sucursal=="") 
        {
          valido = false    
          msg = 'Debe ingresar sucursal de entrega para poder continuar.' 
        }
        if (this.calendario=="") 
        {
          valido = false    
          msg = 'Debe ingresar fecha de despacho para poder continuar.' 
        }
        if (this.condicionVenta=="")
        {
          valido = false    
          msg = 'Debe ingresar condición de venta para poder continuar.'
        } 

        if (!valido)  
        {
          var obj = {
                      txt: msg,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
          this.$store.commit('popup/open',obj);
        }

        return valido
     },


     setPedido(tipoPedido) {
        var IdBorradorPedido = 0 
        var fechaEnt = ''
        var sucursalLinea = 0
        var contactoLinea = 0
        var IdDeposito = this.$store.state.pedido.deposito.Id
        var condicionVenta = 0
        var observacionesFacturacion = ''
        var observacionesPlanta = ''
        var ordenCompra = 0
        var bonificacion = 0
        var bonif = 0
        var bonifDolar = 0
        var cargoMin = 0
        var cargoMinDolar = 0

        this.productos=[]
        this.pedido=''

        var vigenciaMillis = 0
        var actualMillis   = 0 

        if (this.$store.state.user.cliente.BonificacionVigencia) {
            vigenciaMillis = moment(this.$store.state.user.cliente.BonificacionVigencia, "DD/MM/YYYY").toDate().getTime()
            actualMillis   = Date.now()
        }

        // BONIFICACION
        if ((vigenciaMillis)&&(vigenciaMillis>0)&&(actualMillis>0)&&(actualMillis<vigenciaMillis)) {
            if (this.$store.state.user.cliente.BonificacionEsPorcentaje) { 
                bonificacion = (this.$store.state.user.cliente.BonificacionValor/100) * this.calcularSubtotal()   
            } 
            else {
                bonificacion = this.$store.state.user.cliente.BonificacionValor
            } 
        }

        if (this.$store.state.user.cliente.ListaPrecioMoneda == 1) {
            bonif = bonificacion
            bonifDolar = bonificacion / this.$store.state.user.usuario.CotizacionDolar
        }
        else if (this.$store.state.user.cliente.ListaPrecioMoneda == 2) {
            bonif = bonificacion * this.$store.state.user.usuario.CotizacionDolar
            bonifDolar = bonificacion 
        }

        // PEDIDO MINIMO
        if (this.aplicaRecargoPedidoMinimo) 
        {
          // moneda del cargo pedido minimo
          if (this.$store.state.pedido.deposito.Moneda == 1) 
          {
            // si esta en pesos
            cargoMin = this.$store.state.pedido.deposito.CargoPedidoMinimo
            cargoMinDolar = this.$store.state.pedido.deposito.CargoPedidoMinimo / this.$store.state.user.usuario.CotizacionDolar
          }
          if (this.$store.state.pedido.deposito.Moneda == 2) 
          {
            // si esta en dolares
            cargoMin = this.$store.state.pedido.deposito.CargoPedidoMinimo * this.$store.state.user.usuario.CotizacionDolar
            cargoMinDolar = this.$store.state.pedido.deposito.CargoPedidoMinimo
          }
        }
        else
        {
           cargoMin = 0
           cargoMinDolar = 0
        }


        if (tipoPedido == 'pedido')
        {
          IdBorradorPedido = 0 
          var d = new Date(Date.parse(this.calendario))
          fechaEnt = moment(d.getTime()).format("DD/MM/YYYY");             
          sucursalLinea = this.sucursal.Linea       
          contactoLinea = this.contacto.Linea       
          condicionVenta = this.condicionVenta.Id     
          observacionesFacturacion = this.observacionesFacturacion  
          observacionesPlanta = this.observacionesPlanta  
          ordenCompra = this.ordenCompra                
        } 
        else if (tipoPedido == 'borrador') 
        {
          IdBorradorPedido = this.$store.state.pedido.borradorId
          fechaEnt = '01/01/2019'
        }

        var cotizDolar = this.$store.state.user.usuario.CotizacionDolar 

        this.$store.state.pedido.carrito.forEach((item => {
            var precioListaPesos = 0
            var precioListaDolar = 0
            var precioPesos = 0
            var precioDolar = 0
            var descuentoPesos = 0
            var descuentoDolar = 0

            console.log('<1>')
            console.log(item)

            if (this.$store.state.user.cliente.ListaPrecioMoneda == 1) {
                precioPesos = item.precioIngresado
                precioDolar = item.precioIngresado / this.$store.state.user.usuario.CotizacionDolar
                var descuento = item.precioDeLista - item.precioIngresado 
                if (descuento < 0) {
                  descuento = 0
                  precioListaPesos = precioPesos
                  precioListaDolar = precioDolar
                }
                else {
                  precioListaPesos = item.precioDeLista
                  precioListaDolar = item.precioDeLista / this.$store.state.user.usuario.CotizacionDolar
                }
                descuentoPesos = descuento
                descuentoDolar = descuento / this.$store.state.user.usuario.CotizacionDolar
            }
            else if (this.$store.state.user.cliente.ListaPrecioMoneda == 2) {
                precioPesos = item.precioIngresado * this.$store.state.user.usuario.CotizacionDolar
                precioDolar = item.precioIngresado 
                var descuento = item.precioDeLista - item.precioIngresado 
                if (descuento < 0) {
                  descuento = 0
                  precioListaPesos = precioPesos
                  precioListaDolar = precioDolar
                }
                else {
                  precioListaPesos = item.precioDeLista * this.$store.state.user.usuario.CotizacionDolar
                  precioListaDolar = item.precioDeLista 
                }
                descuentoPesos = descuento * this.$store.state.user.usuario.CotizacionDolar
                descuentoDolar = descuento 
            }

            var producto = ''
            if(!item.esPromo) {
                producto = {'ProductoId':item.id,
                            'PromocionId':0,
                            'Largo':0,
                            'Ancho':0,
                            'Cantidad': item.cantidad,
                            'PrecioLista':item.precioDeLista ,
                            'Precio': precioPesos, 
                            'PrecioDolar': precioDolar,     
                            'Descuento': descuentoPesos,                    
                            'DescuentoDolar': descuentoDolar,  
                            'Detalle': item.detalle,          
                            'Descuentos':[]
                        }
            }
            else {
                producto = {'ProductoId':0,
                            'PromocionId':item.promocionId,
                            'Largo':0,
                            'Ancho':0,
                            'Cantidad': item.cantidad,
                            'PrecioLista':precioListaPesos,
                            'Precio': precioPesos, 
                            'PrecioDolar': precioDolar,     
                            'Descuento': descuentoPesos,                    
                            'DescuentoDolar': descuentoDolar,  
                            'Detalle': '',          
                            'Descuentos':[]
                           }
            }
            this.productos.push(producto)
          }));


         this.pedido = {
          'Id': 1,
          'BorradorId': IdBorradorPedido,
          'Fecha': this.getFechaActual(),
          'FechaEntrega': fechaEnt,        
          'FechaTarea': "01/01/2000",
          'ClienteId': this.$store.state.user.cliente.Id,    

          'ClienteSucursalLinea': sucursalLinea,       
          'ClienteContactoLinea': contactoLinea,       
          'DepositoId': IdDeposito,      

          'ListaPrecioId': this.$store.state.user.cliente.ListaPrecioId,                 
          'CondicionVentaId': condicionVenta,     
          'ObservacionesFacturacion': observacionesFacturacion, 
          'ObservacionesPlanta': observacionesPlanta, 

          'CodigoHash': Math.floor(Math.random() * 1000000000),
          'Latitud': 0,
          'Longitud': 0,
          'GpsEncendido': false,

          'ListaPrecioMoneda': this.$store.state.user.cliente.ListaPrecioMoneda,        

          'OrdenCompra': ordenCompra,                
          'Cotizacion': cotizDolar,

          'BonificacionCliente': bonif,         
          'BonificacionClienteDolar': bonifDolar,   
          'CargoPedidoMinimo': cargoMin,   
          'CargoPedidoMinimoDolar': cargoMinDolar,  

          'GiraId': 0,
          'GiraNombre': "",
          'Productos': this.productos,
          'Descuentos': []
         }

         console.log('-----------------')
         console.log(JSON.stringify(this.pedido))
         console.log('-----------------')
     },



     // -----------test-----------
    //  btnEnviarPopup() 
    //  {
    //     this.setPedido('pedido') 
    //  },
     // -----------test-----------


     btnEnviarPopup() 
     {
       if (this.envioValido())
       {
          this.$store.commit('loader/start')
          this.setPedido('pedido') 

         axios.post('/WebSalesPedido', this.pedido ,{
           headers:{
                   Token: this.$store.state.user.usuario.Token,
                   ClientSecret: process.env.CLIENT_SECRET
                  }
          }
         )
          .then((response) => {
            this.showPopup = false;
            this.$store.commit('loader/stop')
            if (response.data.Code == 0)
            {
              if (response.data.Procesado)
              {
                if (this.$store.state.pedido.borradorId != 0)
                {
                  this.eliminarBorrador(this.$store.state.pedido.borradorId)
                }
                else
                {
                  this.$store.commit('pedido/eliminarPedido');
                  this.$router.push({name: 'estadoPedido'});
                }
              } 
              else
              {
                  this.pedido=null
                  this.productos=[]
                  var obj = 
                  {
                    txt: response.data.Mensaje,
                    txtBtnCancel: "",
                    txtBtnOk: "Aceptar",
                    fCancel: null,
                    fOk: null
                  };
                  this.$store.commit("popup/open", obj);
              }
            }
            else {
                var obj = {
                      txt: response.data.Message,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                    }
                this.$store.commit('popup/open',obj);
            }
          })
          .catch((error) => {
                this.$store.commit('loader/stop')
                var obj = {
                    txt: error.Message,
                    txtBtnCancel:'',
                    txtBtnOk:'Aceptar',
                    fCancel:null,
                    fOk:null
                }
                this.$store.commit('popup/open',obj);
          });
        }

     },


     // ----------------------- GUARDAR PEDIDO --------------------------

     btnGuardar() 
     {
       this.$store.commit('loader/start')
       this.setPedido('borrador') 

       axios.post('/WebSalesBorrador', this.pedido ,{
         headers:{
                   Token: this.$store.state.user.usuario.Token,
                   ClientSecret: process.env.CLIENT_SECRET
                 }
         }
       )
        .then((response) => {
          this.$store.commit('loader/stop')
          if (response.data.Code == 0)
          {
            this.$store.commit('pedido/eliminarPedido');
            this.$router.push({name: 'estadoPedido'});
          }
          else if (response.data.Code == 99)
          {
            alert(response.data.Message)
            this.$router.push({name: 'login'});
          }
          else
          {
            console.log(">>>>"+response.data.Message);
            alert(response.data.Message);
          }
        })
        .catch((error) => {
          alert("error")
          console.log(error);
        });
     },



    eliminarBorrador (borradorId) {
      this.$store.commit('loader/start')

      var bdParam = { BorradorId:borradorId,
                      ClienteId:this.$store.state.user.cliente.Id,	
                      EmpleadoId:this.$store.state.user.usuario.EmpleadoId
                    }
                    
      axios.put('/WebSalesBorrador',bdParam,{
      headers:{
                Token: this.$store.state.user.usuario.Token,
                ClientSecret: process.env.CLIENT_SECRET,
                EmpresaId: process.env.EMPRESA_ID
              }
      }
      ).then((response) => {
        this.$store.commit('loader/stop')
        this.$store.commit('pedido/eliminarPedido');
        console.log("eliminar>"+response.data.Mensaje)   
        if (response.data.Code == 0)
         {
           this.$router.push({name: 'estadoPedido'});
         }
         else if (response.data.Code == 99)
         {
           alert(response.data.Message);
         }
         else
         {
           console.log(">>>>"+response.data.Message);
         }
      },(error) => { console.log(error)
            alert(error);  })

    },


     getFechaActual(){
        var date    = new Date();
        return moment(date.getTime() + 10800000).format("DD/MM/YYYY HH:mm");
    },



    calculoFechaEntrega() {
      var Dias =  [0,1,2,3,4,5,6]    
      var DiasNoLaborables = []
      var FeriadosDate = []
      var dayInMillis = 86400000
      var daysOffset = 0
      var date  = new Date();
      var currentMillis = date.getTime()
      var DiasEntrega = 0 
      // calculo dias demora entrega
      this.$store.state.pedido.carrito.forEach((j) =>
      {
        if (j.diasEntrega > DiasEntrega)
        {
          DiasEntrega = j.diasEntrega
        }
      });   
      var HoraCorte = this.$store.state.user.usuario.HoraCorte
      var DiasHabiles =  this.$store.state.user.usuario.DiasHabiles                // empresa
      var DiasHabilesEntrega = this.$store.state.user.cliente.DiasHabilesEntrega   // cliente      
      var Feriados = this.$store.state.user.usuario.Feriados
      // carga array dias habiles
      Dias.forEach((j) =>
      {
        if (!DiasHabiles.includes(j))
        {
          DiasNoLaborables.push(j)
        }
      });   
      // carga array date feriados para el calendario
      Feriados.forEach((j) =>
      {
        var d = new Date(Date.parse(j))      
        FeriadosDate.push(new Date(d.getFullYear(), d.getMonth(), d.getDate()))
      });   
      // calcula hora de corte
      var horaActual = date.getHours() +":"+ date.getMinutes()
      if (Date.parse('01/01/2019 '+horaActual) > Date.parse('01/01/2019 '+HoraCorte))
      {
        daysOffset++
      } 
      while (DiasEntrega > 0)
      {
        daysOffset++
       // console.log("off>"+daysOffset)
        date.setTime(currentMillis+(daysOffset*dayInMillis))  
        if (DiasHabiles.includes(date.getDay()))
        {
          var esFeriado = false  
          Feriados.forEach((j) =>
          {
            var feriado = new Date()
            feriado.setTime(Date.parse(j))
            if ((date.getFullYear()==feriado.getFullYear())
               && (date.getMonth()==feriado.getMonth())
               && (date.getDate()==feriado.getDate())) 
            {
              esFeriado = true
            }
          });   
          if (!esFeriado)
          {
            DiasEntrega--
          }
        }
      }  
      var month = date.getMonth()+1   
      var disables = {
         to:    new Date(date.getFullYear(),date.getMonth(),date.getDate()),
         days:  DiasNoLaborables,
         dates: FeriadosDate
        }
      this.disabledDates = disables
    },
       

    conversionMoneda(monto,origen) {
        var montoConv = 0.0
        var listaPrecio = 0.0

        if (origen == 'producto') {
            listaPrecio = this.$store.state.user.cliente.ListaPrecioMoneda
        } 
        else {
            listaPrecio = this.$store.state.pedido.deposito.Moneda
        }

        if (this.$store.state.pedido.idMoneda != listaPrecio) {
            if (this.$store.state.pedido.idMoneda == 2) {
                montoConv  = monto / this.$store.state.user.usuario.CotizacionDolar
            }
            else if (this.$store.state.pedido.idMoneda == 1) {
                montoConv  = monto * this.$store.state.user.usuario.CotizacionDolar
            }
        }
        else {
            montoConv  = monto 
        }
        return montoConv
    }

   },


   mounted () 
   {
     this.$store.commit('loader/stop')
     localStorage.setItem("lastActivity",Math.floor(Date.now() / 1000));
     this.calculoFechaEntrega()
   }

 }

</script>



<style scoped>


#back-popup{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100vh;
background: #000000;
opacity: 0.6;
filter: alpha(opacity=60);
}



#popup-envio-pedido{
  position: absolute;
  top: 50%;
  left: 50%; 
  transform: translate(-50%,-50%);
  width: 400px;
  border-radius: 15px;
  box-sizing: border-box;
  background: #ffffff;
  border-style: solid;
  border-width: 1px;
  border: 1px solid #dddddd;
}



#popup-btnClose-container{
  display: flex;            
  flex-direction:row;  
  margin-top: 10px;
  height: 20px;
  padding-right: 10px;
  align-items: center;  
  justify-content: flex-end; 
  background:  #ffffff
}


#popup-titulo{
 font-size: 26px;
 color: #5C666F;
 text-align: center;
}

.labelsForms{
 margin-left: 30px;
 font-size: 12px;
 color: #5C666F;
 text-align: left;
}

.labelsFormsInv{
 margin-left: 30px;
 font-size: 12px;
 color: #FF0000;
 text-align: left;
}


#obs
{
  resize: none;
  width: 330px;
  margin-left: 30px;
  margin-bottom: 7px;
  padding: 10px;
  border-radius: 5px;  
  height:40px;
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  font-family: 'Rubik', sans-serif;
}


.wc{
  background-color: #ffffff;
  width: 340px;
  margin-bottom: 20px;
  margin-left: 30px;
  padding-left: 5px;
  border-radius: 5px;
  margin-bottom: 10px;
  height: 30px;
  border-style: solid;
  border: none;
  border-width: 1px;
  border: 1px solid #dddddd;

  -ms-box-sizing:content-box;
  -moz-box-sizing:content-box;
  box-sizing:content-box;
  -webkit-box-sizing:content-box; 
}


select{
  width: 350px;
  height:30px;
  margin-left: 30px;
  padding-left: 5px;
  border-radius: 5px;  
  border-style: solid;
  border:none; 
  border-width: 1px;
  border: 1px solid #dddddd;
  font-family: 'Rubik', sans-serif;
}


select :disabled {
  color:#dddddd;
}

#btnContainerPopup{
  height: 80px;
  display: flex;            
  flex-direction: row;  
  justify-content: center;  
  align-items: center;  
}


#btnclose{
  width: 100px;
  color: #4969B2;
  background: #ffffff; 
  border-width: 1px;
  border: 1px solid #4969B2;
  outline: none;
  height: 30px;
  font-size: 9px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
}

#btnsend{
  width: 100px;
  background: #44C7F4; 
  color: #ffffff;
  outline: none;
  height: 30px;
  font-size: 9px;
  font-weight: bold;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;  
  border-style: solid;
  border:none; 
}



.boton:hover { cursor: pointer; }
#btnClose:hover { cursor: pointer; }



.fadePro-enter {
  opacity: 0;
}
.fadePro-enter-active {
  transition: opacity 0.5s;
}
.fadePro-enter-to {
  opacity: 1;
}
.fadePro-leave {
  opacity: 1;
}
.fadePro-leave-active {
  transition: opacity 0.1s;
}
.fadePro-leave-to {
  opacity: 0;
}



/*----------------------------*/

 #subheader {
  width: 100%;
  height: 35vh;
  background: linear-gradient(#005A9F , #1899D6);
 }

 #main-container{
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 700px;
  height: 85vh;
 }

 #label-container{
  width: 700px;
  height: 10vh;
 }

  #label{
  color:#ffffff;
  font-size: 27px;
 }

  #container{
   width: 700px;
   height: 75vh;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   box-shadow: 3px 3px 4px #dddddd;
   background-color: #ffffff;
   display: flex;
   flex-direction:column;
   align-items: center;
  }


#header-pedido{
 width: 700px;
 height: 50px;
 display: flex;
 flex-direction: row;
 justify-content: center;
 align-items: center;
}

#header-pedidoL{
 width: 230px;
 height: 100%;
 display: flex;
 flex-direction: row;
 background: #ffffff;
 justify-content: flex-start;
 align-items: center;
}

#header-pedidoR{
 width: 400px;
 height: 100%;
 display: flex;
 flex-direction: row;
 background: #ffffff;
 justify-content: flex-end;
 align-items: center;
}


.nPedido{
 font-size: 18px;
 font-weight: bold;
 color:#5D6770;
}


#label-editar{
 font-size: 12px;
 color:#5D6770;
}


#total-container{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}


#list-container{
  width: 660px;
  height: 60vh;
  padding-top: 30px;
  background: #ffffff;
  overflow: auto;
  display: flex;
  flex-direction:column;
  align-items: center;
 }


#btnContainer{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}


.label-form{
 font-size: 12px;
 color:#5D6770;
 display: flex;
 flex-direction: row;
 justify-content: initial;
 align-items: flex-start;
}


#icon:hover
{
  cursor: pointer;
}

#btnEliminar:hover
{
  cursor: pointer;
}

#btnGuardar:hover
{
  cursor: pointer;
}

#btnAgregar:hover
{
  cursor: pointer;
}

#btnEnviar:hover
{
  cursor: pointer;
}



 /* width */
  ::-webkit-scrollbar {
      width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd;
      border-radius: 10px;
  }


  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb;
      border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
  }


  ::-webkit-scrollbar {
  display: block; }



</stylescoped>



// WEBPACK FOOTER //
// src/components/views/pedido/pedido.vue